import { httpGetRequest } from "clients/phronesisClient"
import {
	SWITCHING_BENCHMARK_ENDPOINT,
	SWITCHING_SANKEY_ENDPOINT,
	SWITCHING_TREE_ENDPOINT,
} from "./constants"
import {
	ResponseInformationNode,
	SwitchingBenchmark,
	SwitchingSummarySankey,
} from "./interfaces"

import { RequestParameters } from "components/Shared/Filters/interfaces"

const NUMBER_RETRIES = 0

export const getInformationSwitchingTree = async (
	filters: RequestParameters
): Promise<ResponseInformationNode> => {
	return httpGetRequest<ResponseInformationNode>(
		SWITCHING_TREE_ENDPOINT,
		filters,
		undefined,
		undefined,
		undefined,
		NUMBER_RETRIES
	)
}

export const getSwitchingBenchmarkInformation = async (
	filters: RequestParameters
): Promise<SwitchingBenchmark> => {
	return httpGetRequest<SwitchingBenchmark>(
		SWITCHING_BENCHMARK_ENDPOINT,
		filters,
		undefined,
		undefined,
		undefined,
		NUMBER_RETRIES
	)
}

export const getSwitchingSankeyInformation = async (
	filters: RequestParameters
): Promise<SwitchingSummarySankey> => {
	return httpGetRequest<SwitchingSummarySankey>(
		SWITCHING_SANKEY_ENDPOINT,
		filters,
		undefined,
		undefined,
		undefined,
		NUMBER_RETRIES
	)
}
